$('.testimonial__slider').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    centerMode: true,
    arrows: true,
    nextArrow: '<button class="testimonial2__slider__prev"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"> <rect x="55.5" y="55.5" width="55" height="55" rx="27.5" transform="rotate(-180 55.5 55.5)""></rect><path d="M37 28L19 28M19 28C22.0638 30 26.6596 34.6 26.6596 37M19 28C22.0638 25.625 26.6596 20.5 26.6596 19" stroke="black" stroke-width="2"></path></svg></buttton>',
    prevArrow: '<button class="testimonial2__slider__next"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none""> <rect width="56" height="56" rx="28" fill="none""></rect><path d="M19 28H37M37 28C33.9362 26 29.3404 21.4 29.3404 19M37 28C33.9362 30.375 29.3404 35.5 29.3404 37" stroke="black" stroke-width="2"></path></svg></buttton>',
    centerPadding: '0px',
    infinite: true,
    responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


$(document).ready(function(){
  $('.iwt-list').slick({
       slidesToShow: 4,
       variableWidth: true,
       slidesToScroll: 1,
       autoplay: true,
       autoplaySpeed: 0,
       speed: 8000,
       pauseOnHover: false,
       cssEase: 'linear',
       arrows:false,
       responsive: [
       {
         breakpoint: 991,
         settings: {
           slidesToShow: 3,
           variableWidth: true,
         }
       },
       {
         breakpoint: 751,
         settings: {
           slidesToShow: 2,
           variableWidth: true,
         }
       },
      ]
    });
});

$(document).ready(function() {
    $('.tab-link').click(function() {
        $(this).parents(".tabs-parent").find(".tab").removeClass('tab-active');
        $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
        $(this).parents(".tabs-parent").find(".tab-link").removeClass('active-a');
        $(this).parent().find(".tab-link").addClass('active-a');
    });
});


$('.testimonial2__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    fade:true,
    centerMode: false,
    arrows: true,
    infinite: true,
    nextArrow: '<button class="testimonial2__slider__prev"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"> <rect x="55.5" y="55.5" width="55" height="55" rx="27.5" transform="rotate(-180 55.5 55.5)""></rect><path d="M37 28L19 28M19 28C22.0638 30 26.6596 34.6 26.6596 37M19 28C22.0638 25.625 26.6596 20.5 26.6596 19" stroke="black" stroke-width="2"></path></svg></buttton>',
    prevArrow: '<button class="testimonial2__slider__next"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none""> <rect width="56" height="56" rx="28" fill="none""></rect><path d="M19 28H37M37 28C33.9362 26 29.3404 21.4 29.3404 19M37 28C33.9362 30.375 29.3404 35.5 29.3404 37" stroke="black" stroke-width="2"></path></svg></buttton>',
});


 $('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 5,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   dots: false,
   focusOnSelect: true, 
   arrows: true,  
   nextArrow: '<button class="slider-nav-thumb__next"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="48" height="48" rx="24" fill="white"/><path d="M15 24H33M33 24C29.9362 22 25.3404 17.4 25.3404 15M33 24C29.9362 26.375 25.3404 31.5 25.3404 33" stroke="black" stroke-width="2"/></svg></buttton>',
   prevArrow: '<button class="slider-nav-thumb__prev"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="white"/><path d="M33 24H15M15 24C18.0638 22 22.6596 17.4 22.6596 15M15 24C18.0638 26.375 22.6596 31.5 22.6596 33" stroke="black" stroke-width="2"/></svg></buttton>',
   responsive: [
     {
       breakpoint: 768,
       settings: {
         arrows: false,  
       }
     }
    ]
 });